import * as S from "./SideMenuItem.style";
import { useNavigate } from "react-router";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_rt.svg";
import { useQuery } from "@tanstack/react-query";
import { request } from "@/common/api";
import { GET_COUNT_ALARM } from "@/common/querykeys";
import { useRecoilValue } from "recoil";
import {
  guardianUserState,
  loginTypeState,
  studentUserState,
} from "@/common/states/user";
import { useMemo } from "react";
import { useUserInfo } from "@/common/hooks/useUserInfo";

interface SideMenuItemProps {
  item: any;
}

export const SideMenuItem = ({ item }: SideMenuItemProps) => {
  const navigate = useNavigate();
  const { student, guardian, loginType } = useUserInfo();

  // 학생 || 보호자의 아이디 조회
  const studentId = useMemo(() => {
    return loginType === "student" ? student?.id : guardian?.id;
  }, [student, guardian, loginType]);

  const { data: countAlarmInfo } = useQuery({
    queryKey: [GET_COUNT_ALARM],
    queryFn: async () => {
      return await request<any>({
        method: "GET",
        url: `/push-alarm/count-alarm/${studentId}`,
      });
    },
  });

  return (
    <S.SideMenuItem
      $icon={item.icon ? true : false}
      onClick={
        item.path ? () => navigate(item.path) : item.onClick && item.onClick
      }
    >
      {item.icon && item.icon}
      <S.SideMenuTitle>
        {item.menuTitle && item.menuTitle === "이벤트 및 공지" ? (
          <S.AlarmBox>
            {item.menuTitle}
            {countAlarmInfo?.countUnReadNotice &&
              countAlarmInfo?.countUnReadNotice !== "0" &&
              countAlarmInfo?.countUnReadNotice !== 0 && (
                <S.NewAlarmSquare>
                  {Number(countAlarmInfo.countUnReadNotice) > 99
                    ? 99
                    : countAlarmInfo.countUnReadNotice}
                </S.NewAlarmSquare>
              )}
          </S.AlarmBox>
        ) : item.menuTitle === "알림 관리" ? (
          <S.AlarmBox>
            {item.menuTitle}
            {countAlarmInfo?.countUnRead &&
              countAlarmInfo?.countUnRead !== "0" &&
              countAlarmInfo?.countUnRead !== 0 && (
                <S.NewAlarmSquare>
                  {Number(countAlarmInfo.countUnRead) > 99
                    ? 99
                    : countAlarmInfo.countUnRead}
                </S.NewAlarmSquare>
              )}
          </S.AlarmBox>
        ) : (
          item.menuTitle
        )}
      </S.SideMenuTitle>
      <IconArrow />
    </S.SideMenuItem>
  );
};
